import $ from 'jquery';

export default class DynamicFeaturedCollections {
  constructor({ el }) {
    this.$el = $(el);
    this.initializedClass = 'featured-collections-initialized';
    this._validate();
  }

  update($el) {
    this.$el = $el;
    this._validate();
  }

  _validate() {
    this.transitionend = (function (transition) {
      const transEndEventNames = {
        '-webkit-transition': 'webkitTransitionEnd',
        '-moz-transition': 'transitionend',
        '-o-transition': 'oTransitionEnd',
        transition: 'transitionend',
      };

      return transEndEventNames[transition];
    }(Modernizr.prefixed('transition')));
  }
}
